import { makeStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles(() => ({
  container: {
    paddingBottom: '1.25vh',
    height: '100%',
    '&& .keyboardRoot': {
      overflow: 'visible',
    },
  },
  spacingOffset: {
    margin: '0 -4px',
  },
  icon: {
    '@media (max-width: 1024px)': {
      fontSize: vh(2),
    },
  },
}));
